import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-xiugaimima",
  "use": "icon-icon-xiugaimima-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-xiugaimima\"><path d=\"M512 725.3504c46.9504 0 85.3504-38.4 85.3504-85.3504s-38.4-85.3504-85.3504-85.3504-85.3504 38.4-85.3504 85.3504 38.4 85.3504 85.3504 85.3504z m256-384h-42.6496V256C725.3504 138.24 629.76 42.6496 512 42.6496A213.4016 213.4016 0 0 0 298.6496 256v85.3504H256c-46.9504 0-85.3504 38.4-85.3504 85.2992v426.7008c0 46.8992 38.4 85.2992 85.3504 85.2992h512c46.9504 0 85.3504-38.4 85.3504-85.2992V426.6496c0-46.8992-38.4-85.2992-85.3504-85.2992zM379.7504 256A132.4032 132.4032 0 0 1 512 123.7504 132.4032 132.4032 0 0 1 644.2496 256v85.3504H379.7504V256zM768 853.3504H256V426.6496h512v426.7008z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-xiugaimima.svg
// module id = xfOw
// module chunks = 3